module.exports = __webpack_public_path__ + "img/credit-agricole-logo.a688e2b7.svg";